import {
    useMutation,
    useQueryClient,
    UseMutationResult,
} from '@tanstack/react-query'
import { IRule, IRuleSet } from '../../interfaces'
import { updateRule } from '../../../../services/dtServices'

type UpdateRuleVariables = IRule & { attributeValues: Record<string, string> }

export const useUpdateRule = (
    orgId: string,
    ruleSetId: string,
    entityId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof updateRule>>,
    Error,
    UpdateRuleVariables
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (rule: UpdateRuleVariables) => {
            return updateRule(orgId, rule)
        },

        // client side optimistic update
        onMutate: (newRuleInfo: IRule) => {
            queryClient.setQueryData(
                ['rulesets', orgId, entityId],
                (ruleSets: any) =>
                    ruleSets?.data?.map((ruleSet: IRuleSet) =>
                        ruleSet.id === ruleSetId
                            ? {
                                  ...ruleSet,
                                  rules: ruleSet.rules.map((rule: any) =>
                                      rule.id === newRuleInfo.id
                                          ? newRuleInfo
                                          : rule,
                                  ),
                              }
                            : ruleSet,
                    ),
            )
        },
        // refetch rules after mutation
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['rulesets', orgId, entityId],
            }),
    })
}
